<template>
  <div class="cookie-disclaimer">
    <h2 class="cookie-disclaimer__headline">
      {{ $t("headline") }}
    </h2>
    <p class="cookie-disclaimer__copy">
      {{ $t("copy") }}
      <a
        :href="$options.privacyPath"
        class="cookie-disclaimer__privacy">
        <span>{{ $t("privacy") }}</span>
      </a>
    </p>
    <div class="cookie-disclaimer__actions">
      <button
        class="cookie-disclaimer__cta js-pw-link"
        @click="$store.dispatch('consentAllCookies')"
        data-event-category="popup-20200728-cookie_disclaimer_all"
        data-event-depth="1"
        data-event-action="click">
        <span class="button button--full button--midnight">{{ $t('allCookies') }}</span>
      </button>
      <span
        class="cookie-disclaimer__settings js-pw-link"
        data-modal-open-step="cookie-banner:settings"
        data-event-category="popup-20200728-cookie_disclaimer_settings"
        data-event-depth="1"
        data-event-action="click">
        <span>{{ $t('cookieSettings') }}</span>
      </span>
    </div>
  </div>
</template>

<script>
import globals from "/utils/globals";

export default {
  name: "CookieDisclaimer",
  privacyPath: globals.routes.privacyCookiebot,
  i18n: {
    messages: {
      en: {
        headline: "This website uses cookies",
        copy: "We use them to offer you a better browsing experience, enable social media features, personalise ads and to analyse the traffic.",
        privacy: "Our privacy policy",
        allCookies: "Allow all cookies",
        cookieSettings: "Change cookie settings"
      },
      de: {
        headline: "Ein Hinweis zu Cookies",
        copy: "Wir möchten Cookies dafür nutzen, unsere Website zu analysieren und sie für dich zu verbessern, sowie für Werbezwecke.",
        privacy: "Unsere Datenschutzbestimmung",
        allCookies: "Alle Cookies erlauben",
        cookieSettings: "Cookie-Einstellungen anpassen"
      }
    }
  }
};
</script>

<style lang="scss">
.cookie-disclaimer {
  @include font-family(sans-serif);

  max-width: 30rem;
  padding: $spacing-24 $spacing-16;

  &__headline {
    @include font-style(h3);

    margin-bottom: $spacing-8;
  }

  &__copy {
    @include font-style(p);

    margin-bottom: $spacing-24;
  }

  &__privacy {
    display: inline-block;
  }

  &__actions {
    display: flex;
    flex-direction: column;
    align-items: center;
  }

  &__cta {
    width: 100%;
    margin-bottom: $spacing-16;

    font-family: inherit;

    cursor: pointer;

    /* stylelint-disable-next-line selector-nested-pattern */
    span {
      display: block;
      width: 100%;
      height: 100%;
    }
  }

  &__settings {
    @include font-style(button, $color: $mid-grey);

    font-family: inherit;

    cursor: pointer;

    &:hover {
      color: $midnight;
    }
  }

  @include media(min-width, m) {
    padding: $spacing-24 $spacing-24;
  }
}
</style>
